import { API_URL } from "./common";

export interface NonWorkDay {
  id: number;
  date: string;
  type: string;
  name: string;
  isWorking: boolean;
}

export const getNonWorkDays = async (
  token: string,
  year: number,
  month?: number,
): Promise<NonWorkDay[]> => {
  const params = new URLSearchParams({ year: String(year) });
  if (month !== undefined) params.set("month", String(month));

  const response = await fetch(
    `${API_URL}/v1/ecommerce/settings/calendar?${params}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch calendar: ${response.status}`);
  }

  return response.json();
};

export const createNonWorkDay = async (
  token: string,
  date: string,
  name: string,
  isWorking = false,
): Promise<NonWorkDay> => {
  const response = await fetch(
    `${API_URL}/v1/ecommerce/settings/calendar`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ date, name, isWorking }),
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to create calendar entry: ${response.status}`);
  }

  return response.json();
};

export const updateNonWorkDay = async (
  token: string,
  id: number,
  isWorking: boolean,
  name?: string,
): Promise<NonWorkDay> => {
  const body: { isWorking: boolean; name?: string } = { isWorking };
  if (name != null) body.name = name;

  const response = await fetch(
    `${API_URL}/v1/ecommerce/settings/calendar/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to update calendar entry: ${response.status}`);
  }

  return response.json();
};
